import React, { useEffect, useState } from "react";
import styled from "styled-components";
import OwlCarousel from "react-owl-carousel";
import testimonialArray from "../../TestimonialData.js";

const TestimonialArea = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    setTestimonials(testimonialArray);
  }, []);

  const options = {
    loop: true,
    margin: 30,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      1200: { items: 3 },
    },
  };

  return (
    <Wrapper>
      <div className="testimonial-area">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="section-title center">
                <div className="section-thumb">
                  <img
                    src="/assets/images/home-1/section-shape111.png"
                    alt=""
                  />
                </div>
                <h1>Customer’s feedback about resort</h1>
              </div>
            </div>
          </div>
          <div className="row">
            {testimonials.length > 0 && (
              <OwlCarousel className="testi-list" {...options}>
                {testimonials &&
                  testimonials.map((testimonial) => (
                    <div className="col-lg-12" key={testimonial.id}>
                      <div
                        className="single-testi-box"
                        style={{
                          height: "600px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          padding: "20px",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <div className="testi-quote-icon">
                          <img src={testimonial.quoteIcon} alt="Quote Icon" />
                        </div>
                        <div className="testi-rating">
                          <ul>
                            {Array.from({ length: 5 }, (_, index) => {
                              const starType =
                                testimonial.rating >= index + 1
                                  ? "bi bi-star-fill"
                                  : testimonial.rating > index
                                  ? "bi bi-star-half"
                                  : "bi bi-star";
                              return (
                                <li key={index}>
                                  <i className={starType}></i>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        <div
                          className="testi-content"
                          style={{ textAlign: "justify", flexGrow: 1 }}
                        >
                          <p>{testimonial.content}</p>
                        </div>
                        <div
                          className="testi-author"
                          style={{ marginTop: "auto" }}
                        >
                          <div className="testi-author-thumb">
                            <img
                              src={testimonial.authorImage}
                              alt={testimonial.authorName}
                              style={{
                                height: "70px",
                                width: "70px",
                                borderRadius: "50%",
                                border: "1px solid #C19D67",
                              }}
                            />
                          </div>
                          <div className="testi-author-title">
                            <h4>{testimonial.authorName}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </OwlCarousel>
            )}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .owl-nav {
    display: none !important;
  }
  .testi-content p:before {
    position: absolute;
    content: "";
    width: 1px;
    /* height: 35px; */
    height: 0px;
    left: 0;
    /* bottom: -41px; */
    bottom: 0px !important;
    background: #c29d68;
  }
`;

export default TestimonialArea;
